import { useTranslation } from 'react-i18next';
import { useGame } from '~/hooks/models/useGame';
import { GameRunner, GameRunnerVersion } from '~/components/GameRunner';
import { LoadingPage } from '../LoadingPage';

export function GameGamepad({ gameID }: { gameID: string }) {
    const { t } = useTranslation();
    const game = useGame(gameID);

    if (!game) {
        return <LoadingPage>{t('gamepad.loadingGame')}</LoadingPage>;
    }

    if (!game.gamepadURL) {
        return <LoadingPage>{t('gamepad.gameError')}</LoadingPage>;
    }

    return (
        // Visible-viewport height (100dvh), NOT 100vh: the game fills this iframe,
        // and on mobile 100vh is the LARGE viewport (includes the area behind the
        // URL bar), so a 100vh iframe renders the game taller than what's on screen
        // → the bottom (e.g. Draw Guessr's tool row) falls below the fold. With the
        // gamepad scroll now locked (index.css .gamepadScrollLock) that bottom is
        // unreachable. 100dvh tracks the actual visible area so everything fits.
        // `gamepadGameHost` keeps a 100vh fallback for browsers without dvh.
        <div className="gamepadGameHost">
            <GameRunner
                title={game.id}
                src={game.gamepadURL}
                version={(game.ubVersion as GameRunnerVersion) || 'latest'}
            />
        </div>
    );
}
